import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import type { Config } from '../';
import content from '../../../../.contentlayer/generated/PrivacyPolicy/privacyPolicy__nl-NL.mdx.json';

export const config: Config = {
  layout: { ...sharedConfig['nl-NL'].layout },
  seo: {
    ...sharedConfig['nl-NL'].seo,
    title: 'Privacybeleid • Lemonade Verzekering NL',
    metaTitle: 'Privacybeleid • Lemonade Verzekering NL',
    description:
      'Lees het privacybeleid van Lemonade Nederland voor informatie over hoe wij je persoonsgegevens verzamelen, gebruiken, beveiligen en beschermen.',
  },
  MDXContent: content as DocumentTypes,
};
